module.exports = __webpack_public_path__ + "static/media/ap.031a9ed0.svg";